/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';
import type { EnrollmentStatus } from './EnrollmentStatus';
import {
    EnrollmentStatusFromJSON,
    EnrollmentStatusFromJSONTyped,
    EnrollmentStatusToJSON,
    EnrollmentStatusToJSONTyped,
} from './EnrollmentStatus';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface RecentEnrollmentStatusChangeItem
 */
export interface RecentEnrollmentStatusChangeItem {
    /**
     * 
     * @type {string}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    id: string;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    activityId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    enrollmentId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    studentId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    studentName: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    classId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    className: string;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    locationId: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {EnrollmentStatus}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    status: EnrollmentStatus;
    /**
     * 
     * @type {string}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    statusLabel: string;
    /**
     * 
     * @type {string}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    activityCategory: string;
    /**
     * 
     * @type {Date}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    changedAt: Date;
    /**
     * 
     * @type {any}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    dropDate: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof RecentEnrollmentStatusChangeItem
     */
    studioInitiated: boolean;
}



/**
 * Check if a given object implements the RecentEnrollmentStatusChangeItem interface.
 */
export function instanceOfRecentEnrollmentStatusChangeItem(value: object): value is RecentEnrollmentStatusChangeItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('activityId' in value) || value['activityId'] === undefined) return false;
    if (!('enrollmentId' in value) || value['enrollmentId'] === undefined) return false;
    if (!('studentId' in value) || value['studentId'] === undefined) return false;
    if (!('studentName' in value) || value['studentName'] === undefined) return false;
    if (!('classId' in value) || value['classId'] === undefined) return false;
    if (!('className' in value) || value['className'] === undefined) return false;
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('activityCategory' in value) || value['activityCategory'] === undefined) return false;
    if (!('changedAt' in value) || value['changedAt'] === undefined) return false;
    if (!('dropDate' in value) || value['dropDate'] === undefined) return false;
    if (!('studioInitiated' in value) || value['studioInitiated'] === undefined) return false;
    return true;
}

export function RecentEnrollmentStatusChangeItemFromJSON(json: any): RecentEnrollmentStatusChangeItem {
    return RecentEnrollmentStatusChangeItemFromJSONTyped(json, false);
}

export function RecentEnrollmentStatusChangeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentEnrollmentStatusChangeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'activityId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['activityId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['enrollmentId']),
        'studentId': ApiUserTasksGetPageParameterFromJSON(json['studentId']),
        'studentName': json['studentName'],
        'classId': ApiUserTasksGetPageParameterFromJSON(json['classId']),
        'className': json['className'],
        'locationId': ActorActivityRecordActorUserIdFromJSON(json['locationId']),
        'status': EnrollmentStatusFromJSON(json['status']),
        'statusLabel': json['statusLabel'],
        'activityCategory': json['activityCategory'],
        'changedAt': (new Date(json['changedAt'])),
        'dropDate': json['dropDate'],
        'studioInitiated': json['studioInitiated'],
    };
}

export function RecentEnrollmentStatusChangeItemToJSON(json: any): RecentEnrollmentStatusChangeItem {
    return RecentEnrollmentStatusChangeItemToJSONTyped(json, false);
}

export function RecentEnrollmentStatusChangeItemToJSONTyped(value?: RecentEnrollmentStatusChangeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'activityId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['activityId']),
        'enrollmentId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['enrollmentId']),
        'studentId': ApiUserTasksGetPageParameterToJSON(value['studentId']),
        'studentName': value['studentName'],
        'classId': ApiUserTasksGetPageParameterToJSON(value['classId']),
        'className': value['className'],
        'locationId': ActorActivityRecordActorUserIdToJSON(value['locationId']),
        'status': EnrollmentStatusToJSON(value['status']),
        'statusLabel': value['statusLabel'],
        'activityCategory': value['activityCategory'],
        'changedAt': value['changedAt'].toISOString(),
        'dropDate': value['dropDate'],
        'studioInitiated': value['studioInitiated'],
    };
}

